// ======================================================================
// File Name       : SuperuserEnterpriseRoleAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { SUPERUSER_ENTERPRISE_ROLE_RECEIVE_LIST } from '../constants/ActionTypes';
import { SUPERUSER_RECEIVE_SETTING_LIST } from '../constants/actionTypes/superUser';
import { commonCallApi } from '../utils/ApiUtils';

function receiveSuperuserEnterpriseRoleList(roleList) {
  return {
    type: SUPERUSER_ENTERPRISE_ROLE_RECEIVE_LIST,
    roleList,
  };
}

export function getSuperuserEnterpriseRoleList(param) {
  return dispatch =>
    commonCallApi({
      path: 'superuserEnterpriseRole/GetList',
      data: param,
      enterpriseId: 1,
    }).then((resdata) => {
      const { roleList } = resdata;
      dispatch(receiveSuperuserEnterpriseRoleList(roleList));
    });
}

export function superuserEnterpriseRoleEdit(param) {
  return (dispatch) => commonCallApi({
    path: 'superuserEnterpriseRole/Edit',
    data: param,
    enterpriseId: 1,
  });
}
